export enum SshTunnelStatus {
    DISCONNECTED = 'disconnected',
    CONNECTING = 'connecting',
    CONNECTED = 'connected',
    RECONNECTING = 'reconnecting',
    FAILED = 'failed',
}

export type SshTunnelFailureReason =
    | 'none'
    | 'auth_rejected'
    | 'host_key_mismatch'
    | 'invalid_config'
    | 'port_in_use'
    | 'unreachable'
    | 'retries_exhausted';

export interface TunnelHealthDto {
    status: SshTunnelStatus;
    lastError: string | null;
    connectedSince: string | null;
    attempt: number;
    failureReason: SshTunnelFailureReason;
}
